var _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_07_postprod",
    "data-name": "07_postprod",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 156,
    height: 156,
    fill: "rgba(0,0,0,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkle2",
    transform: "translate(112.13 110.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4564",
    "data-name": "Path 4564",
    d: "M1733.533,1725.137l2.223.409h-2.223l-.211-1.162-.192-1.077-.175-.994-.161-.914-.148-.838-.139-.764-.131-.694-.126-.626-.123-.562-.121-.5-.122-.438-.122-.379-.124-.325-.125-.273-.126-.227-.129-.19-.135-.163-.148-.145-.17-.137-.2-.133-.239-.133-.283-.136-.33-.138-.379-.142-.428-.148-.479-.157-.531-.168-.583-.184-.637-.2-.693-.223-.75-.249-.809-.277.745-2.134.786.27.731.242.678.219.63.2.585.184.544.173.507.167.473.165.444.168.42.176.4.191.378.212.359.239.336.271.31.3.28.336.249.366.218.393.192.419.171.448.154.48.143.516.136.558.132.6.132.658.135.715.141.777.15.844.161.915.174.991.191,1.07.21,1.155h-2.223Zm2.223,0a1.13,1.13,0,1,1-2.223.409Zm8.324-12.289.745-2.134v2.134l-.809.277-.75.249-.693.223-.638.2-.583.184-.531.169-.479.157-.428.148-.379.142-.33.139-.283.135-.239.134-.2.133-.17.137-.148.145-.135.162-.129.19-.126.227-.124.273-.124.325-.122.379-.122.438-.122.5-.123.561-.126.626-.131.694-.139.764-.148.838-.161.914-.175.993-.192,1.077-.211,1.162-2.223-.409.21-1.155.191-1.07.174-.99.161-.915.15-.844.141-.777.135-.715.132-.658.132-.606.136-.558.143-.516.154-.48.171-.448.192-.42.219-.393.248-.366.28-.337.31-.3.336-.27.359-.239.378-.212.4-.191.419-.176.444-.168.473-.165.507-.167.544-.173.585-.185.63-.2.678-.219.73-.242.786-.27v2.134Zm0-2.134a1.13,1.13,0,1,1,.745,2.134l-.745-2.134Zm-8.324-12.288-2.223-.409h2.223l.211,1.162.192,1.077.175.994.161.914.148.838.139.764.131.694.125.626.123.561.122.5.122.438.122.379.124.325.124.273.126.227.129.19.135.162.148.146.17.137.2.133.239.134.284.135.329.139.379.142.428.149.479.157.531.169.583.184.638.2.693.223.75.249.809.277-.745,2.134-.786-.269-.73-.243-.678-.219-.63-.2-.585-.185-.543-.172-.507-.167-.473-.165-.444-.167-.42-.176-.4-.191-.378-.211-.358-.239-.336-.271-.31-.3-.28-.336-.249-.366-.219-.393-.192-.42-.17-.448-.154-.48-.143-.516-.136-.558-.132-.606-.132-.658-.135-.715-.141-.777-.15-.844-.161-.915-.174-.991-.191-1.07-.21-1.155h2.223Zm-2.223,0a1.13,1.13,0,0,1,2.223-.409Zm-8.324,12.288-.745,2.134v-2.134l.809-.277.75-.249.693-.223.637-.2.583-.184.531-.169.479-.157.428-.149.379-.142.33-.139.284-.135.239-.133.2-.133.17-.137.148-.145.135-.163.129-.19.126-.227.125-.273.124-.325.122-.379.122-.438.121-.5.123-.561.126-.626.131-.694.139-.764.148-.838.161-.914.175-.994.192-1.077.211-1.162,2.223.409-.21,1.155-.191,1.07-.174.991-.161.915-.15.844-.141.777-.135.715-.132.658-.132.6-.136.558-.143.516-.154.48-.171.448-.192.419-.218.393-.249.366-.28.336-.31.3-.336.271-.359.239-.378.212-.4.191-.42.176-.444.167-.473.165-.507.167-.543.173-.585.184-.63.2-.678.219-.73.243-.786.269v-2.134Zm0,2.134a1.13,1.13,0,1,1-.745-2.134l.745,2.134Z",
    transform: "translate(-1723.706 -1697.092)",
    fill: "#dbb258"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sparkle1",
    transform: "translate(21.995 16.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4565",
    "data-name": "Path 4565",
    d: "M343.355,260.145l2.01,1.034-2.006.008-.1-.183-.1-.181-.1-.178-.108-.176-.112-.174-.115-.172-.118-.169-.121-.167-.125-.165-.127-.162-.13-.159-.133-.157-.137-.154-.139-.152-.142-.15-.145-.146-.148-.144-.15-.141-.153-.137-.155-.135-.159-.132-.162-.13-.163-.126-.165-.122-.168-.12-.171-.116-.173-.114-.174-.11-.178-.107-.18-.1-.181-.1-.183-.1,1.034-2.01.222.117.219.121.217.126.214.129.212.133.208.137.206.141.2.145.2.148.2.152.194.155.191.159.189.163.185.167.181.17.179.173.175.177.172.18.169.183.165.187.161.19.158.193.154.2.15.2.147.2.143.2.139.208.135.211.131.214.128.216.123.219.119.222-2.006.008Zm2.006-.008a1.13,1.13,0,0,1-2,1.049ZM348.9,256.6l1.051-2-.008,2.006-.183.1-.181.1-.179.1-.176.107-.175.111-.172.113-.169.116-.167.119-.165.122-.163.126-.159.128-.156.131-.155.135-.152.137-.148.14-.146.143-.143.146-.141.149-.137.151-.135.154-.132.157-.129.159-.126.162-.122.165-.12.168-.116.169-.113.172-.111.176-.107.176-.1.178-.1.182-.1.183-2.01-1.034.117-.223.121-.219.126-.218.129-.214.133-.211.137-.209.141-.206.145-.2.148-.2.153-.2.156-.193.16-.19.163-.187.168-.184.17-.18.174-.177.177-.174.181-.171.184-.167.187-.163.191-.16.194-.156.2-.152.2-.149.2-.145.206-.141.208-.137.211-.133.214-.129.217-.126.219-.121.222-.117L348.9,256.6Zm.008-2.006a1.13,1.13,0,1,1,1.034,2.01Zm-3.538-3.581-2.006-1.041,2.007,0,.1.183.1.182.1.179.107.177.11.175.113.172.117.17.12.168.124.167.126.163.129.161.132.159.135.156.139.154.141.151.144.148.146.145.149.142.152.141.155.137.157.133.159.13.163.128.165.125.167.121.17.118.171.114.174.111.176.109.178.1.181.1.182.1-1.051,2-.221-.119-.219-.123-.217-.128-.213-.131-.21-.135-.208-.139-.2-.143-.2-.147-.2-.151-.2-.154-.194-.159-.19-.162-.186-.165-.183-.168-.18-.172-.178-.176-.173-.179-.17-.182-.167-.185-.163-.188-.159-.191-.157-.2-.152-.2-.148-.2-.145-.2-.141-.206-.137-.209-.133-.212-.129-.214-.125-.217-.121-.219-.117-.222,2.008,0Zm-2.007,0a1.13,1.13,0,1,1,2.009-1.035l-2.01,1.035Zm-3.59,3.59-1.034,2.01,0-2.008.184-.1.181-.1.179-.1.178-.109.176-.112.173-.114.17-.118.169-.122.167-.124.163-.128.161-.131.159-.134.157-.137.154-.14.152-.143.148-.146.146-.148.143-.151.141-.154.137-.155.133-.159.131-.162.128-.164.124-.166.122-.169.118-.17.115-.173.112-.176.108-.178.1-.179.1-.181.1-.183,2.006,1.041-.118.222-.122.221-.128.218-.131.215-.135.212-.139.209-.143.207-.146.2-.151.2-.154.2-.157.194-.162.192-.166.189-.168.185-.172.182-.176.179-.179.176-.182.172-.185.168-.189.165-.192.161-.195.157-.2.154-.2.15-.2.146-.208.143-.209.139-.211.135-.214.131-.218.128-.221.123-.222.118,0-2.007Zm0,2.007a1.13,1.13,0,1,1-1.043-2Z",
    transform: "translate(-338.124 -249.362)",
    fill: "#dbb258"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "diamond"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4566",
    "data-name": "Path 4566",
    d: "M442.33,465.881l18.553-15.048,17.969-10.382h25.411l17.963,10.382,18.554,15.048v23.54l-49.826,48.6-48.624-48.6Z",
    transform: "translate(-413.556 -411.798)",
    fill: "rgba(0,0,0,0)",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4567",
    "data-name": "Path 4567",
    d: "M727.54,600.05v14.668l17.969,10.376H770.92l17.963-10.376V600.05",
    transform: "translate(-680.212 -561.016)",
    fill: "rgba(0,0,0,0)",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M442.33,1193.25l28.837,16.653h40.781l28.832-16.653",
    transform: "translate(-413.556 -1115.627)",
    fill: "rgba(0,0,0,0)",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 18.553,
    y2: 23.921,
    transform: "translate(28.774 53.702)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4569",
    "data-name": "Path 4569",
    d: "M893.315,985.03l-7.685,30.2,19.787,31.944",
    transform: "translate(-828.018 -920.952)",
    fill: "rgba(0,0,0,0)",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4570",
    "data-name": "Path 4570",
    d: "M1203.109,985.03l7.685,30.2-20.994,31.944",
    transform: "translate(-1112.402 -920.952)",
    fill: "rgba(0,0,0,0)",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 18.554,
    y2: 23.921,
    transform: "translate(108.67 53.702)",
    fill: "none",
    stroke: "#dbb258",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.6086f5474f87caa32ed18722349c8328.svg";
export { ForwardRef as ReactComponent };